export var ANGULAR_TEMPLATE = {
  files: {
    "/src/app/app.component.css": {
      code: "div {\n    text-align: center;\n}              \n"
    },
    "/src/app/app.component.html": {
      code: "<div>\n<h1>\n    {{ helloWorld }}\n</h1>\n</div>         \n"
    },
    "/src/app/app.component.ts": {
      code: "import { Component } from \"@angular/core\";\n\n@Component({\n    selector: \"app-root\",\n    templateUrl: \"./app.component.html\",\n     styleUrls: [\"./app.component.css\"]\n})\nexport class AppComponent {\n    helloWorld = \"hello world\";\n}                   \n"
    },
    "/src/app/app.module.ts": {
      code: "import { BrowserModule } from \"@angular/platform-browser\";\nimport { NgModule } from \"@angular/core\";\n            \nimport { AppComponent } from \"./app.component\";\n            \n@NgModule({\n    declarations: [AppComponent],\n    imports: [BrowserModule],\n    providers: [],\n    bootstrap: [AppComponent]\n})\nexport class AppModule {}           \n"
    },
    "/src/index.html": {
      code: "<!doctype html>\n<html lang=\"en\">\n            \n<head>\n    <meta charset=\"utf-8\">\n    <title>Angular</title>\n    <base href=\"/\">\n            \n    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n    <link rel=\"icon\" type=\"image/x-icon\" href=\"favicon.ico\">\n</head>\n            \n<body>\n   <app-root></app-root>\n</body>\n            \n</html>\n"
    },
    "/src/main.ts": {
      code: "import { enableProdMode } from \"@angular/core\";\nimport { platformBrowserDynamic } from \"@angular/platform-browser-dynamic\";\n            \nimport { AppModule } from \"./app/app.module\";            \n\nplatformBrowserDynamic()\n    .bootstrapModule(AppModule)\n    .catch(err => console.log(err));\n            \n"
    },
    "/src/polyfills.ts": {
      code: "import \"core-js/proposals/reflect-metadata\";   \n            import \"zone.js/dist/zone\";\n"
    }
  },
  dependencies: {
    "@angular/core": "^11.2.0",
    "@angular/platform-browser": "^11.2.0",
    "@angular/platform-browser-dynamic": "^11.2.0",
    "@angular/common": "^11.2.0",
    "@angular/compiler": "^11.2.0",
    "zone.js": "0.11.3",
    "core-js": "3.8.3",
    rxjs: "6.6.3"
  },
  entry: "/src/main.ts",
  main: "/src/app/app.component.ts",
  environment: "angular-cli"
};